import React from 'react';

import IContact from 'interfaces/contacts/IContact';

// A locked supplier is not chosen any more; the one already chosen is still shown
export default (
  suppliers: IContact[],
  chosenId?: null | number
): JSX.Element[] => {
  const shown = suppliers.filter(
    (supplier) => !supplier.locked || supplier.id === chosenId
  );
  if (shown.length === 0) {
    return [];
  }

  const getBusinessId = (supplier: IContact) =>
    !supplier.businessId ? null : `(${supplier.businessId})`;

  return [
    <option key="supplier-00" value="" />,
    ...shown.map((supplier) => (
      <option key={`supplier-${supplier.id}`} value={supplier.id}>
        {supplier.companyName} {getBusinessId(supplier)}
        {supplier.locked ? ' 🔒' : ''}
      </option>
    )),
  ];
};
